<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import scholarshipApi from '@/services/api/scholarship.api'
import codeApi from '@/services/api/code.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Estatus de Pago Estudiante BECA',
      routes: ['Informes', 'Informe de Estatus de Pago Estudiante BECA'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          disciplineTypeServices: [],
        },
        filters: {
          academicYear: null,
          disciplineTypeService: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Fiscal',
          placeholder: 'Seleccionar',
          error: 'Favor de seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'disciplineTypeService',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Servicio',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-3',
          options: this.model.search.collections.disciplineTypeServices,
          value: this.model.search.filters.disciplineTypeService,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          error: 'Favor de entrar un número de SIE.',
          validations: 'required',
          icon: 'fa fa-search orange-icon',
          class: 'col-md-3',
          leftIcon: true,
          value: this.model.search.filters.sie,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )

      await this.getDisciplineTypeServices()
    },
    async getDisciplineTypeServices() {
      await codeApi.getDisciplineTypeServices().then((res) => {
        this.model.search.collections.disciplineTypeServices = res.data
      })
    },
    async onHandlerSearch() {

      if (
        !(this.model.search.filters.academicYear !== null &&
        this.model.search.filters.academicYear !== undefined &&
        this.model.search.filters.sie !== '')
      ) {
        return
      }

      let hasPayments = await this.doesStudentHasPayments()

      if (!hasPayments) {
        this.ShowToast('Atención', 'El estudiante entrado no cuenta con pagos en sistema para el año seleccionado.', 'info')

        return
      }

      this.process()
    },
    async doesStudentHasPayments() {

      return scholarshipApi.getStudentHasPaymentsForAcademicYear({
        academicYearId: this.model.search.filters.academicYear.id,
        studentSieId: this.model.search.filters.sie,
      })
      .then((res) => {
        return res.data
      })
    },
    async process() {
      const report = 'scholarshipstudentpaymentsstatus'
      reportApi
        .getReport(report, {
          academicYearId: this.model.search.filters.academicYear?.id,
          disciplineTypeId: this.model.search.filters.disciplineTypeService?.id,
          studentSieId: this.model.search.filters.sie,
        })
        .then((res) => {
          DocumentsService.Download(res.data)
        })
        .catch((err) => {
          this.ShowToast(`Error (${err.status})`, 'Ocurrió un error mientras se generaba el reporte.', 'error')
        })
    },
  },
}
</script>
